export const ID_TOKEN_EXPIRATION_OFFSET = 60 * 1000;
export const ID_TOKEN_EXPIRATION_MINIMUM = 15 * 60 * 1000;
